/* eslint-disable camelcase */

const getOrderFromReservationDetails = (reservation) => {
  // const payment = reservation?.payment;
  const invoice = reservation?.payment?.invoice;
  const currencyCode = reservation?.currencyCode;

  if (!invoice) {
    return undefined;
  }

  return {
    currencyCode: currencyCode || 'USD',
    items: invoice?.items,
    quantity: invoice?.quantity,
    reservationCharge: invoice?.reservation_charge,
    reservationItemName: reservation?.tableType,
    resyFee: invoice?.resy_fee,
    serviceFee: invoice?.service_fee,
    serviceCharge: invoice?.service_charge,
    subtotal: invoice?.subtotal,
    tax: invoice?.tax,
    total: invoice?.total,
  };
};

export default getOrderFromReservationDetails;
